// Chakra imports
import {
  Box,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import React from "react";
import { useClerkAuth } from "../../../../hooks/useClerkAuth";
// Framer Motion
import { motion } from "framer-motion";
import auraPeakingOutOfCorner from "../../../../assets/img/Aura Peaking Out Of The Corner.png";

interface GreetingProps {
  children?: React.ReactNode;
}

const Greeting: React.FC<GreetingProps> = ({ children }) => {
  const textColor = "white";
  const { user, isLoaded } = useClerkAuth();

  // Get time-based greeting
  const getTimeBasedGreeting = (): string => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return "Good Morning";
    } else if (hour >= 12 && hour < 17) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  // Get user's name (prefer firstName, fallback to full name, then "there")
  const getUserName = (): string => {
    if (user?.firstName) {
      return user.firstName;
    }
    if (user?.lastName) {
      return user.lastName;
    }
    return "there";
  };

  const userName = getUserName();
  const greetingText = isLoaded ? `${getTimeBasedGreeting()}, ${userName}!` : "Welcome Back!";

  return (
    <motion.div
      key="greeting-banner"
      initial={{ opacity: 1, y: 0, scale: 1 }}
      style={{ overflow: "hidden" }}
    >
          <Card
            h={{ base: "50px", lg: "48px" }}
            w="100%"
            bg="linear-gradient(135deg, #38BBD1, #3EEAEC)"
            position="relative"
            overflow="hidden"
            borderRadius="6px"
          >
      {/* Aura Image */}
      <Box
        position="absolute"
        bottom="-10px"
        left="0"
        maxW="80px"
        maxH="80px"
        zIndex={1}
        transform="scaleX(-1)"
      >
        {/* @ts-ignore - Chakra UI complex union type limitation */}
        <Image
          src={auraPeakingOutOfCorner}
          alt="Aura"
          w="100%"
          h="100%"
          objectFit="contain"
        />
      </Box>
      <CardBody display='flex' alignItems='center' justifyContent='flex-start' h='100%' py={0} pl={{ base: "16px", lg: "16px" }} pr={0} position="relative">
        <Flex flexDirection='row' align='center' justify='space-between' w='100%' h='100%' alignItems="center">
          {children || (
            <>
              <Flex flexDirection='row' align='center' justify='flex-start' ml={{ base: "20px", sm: "28px", md: "35px", lg: "40px", xl: "40px" }} gap={{ base: 3, lg: 4 }} flexWrap="wrap" alignItems="center" h='100%'>
                <Text fontSize={{ base: "lg", lg: "xl" }} color={textColor} fontWeight='medium' fontFamily="'Urbanist', sans-serif" whiteSpace="nowrap" lineHeight="1" m={0} display="flex" alignItems="center" h='100%'>
                  {greetingText}
                </Text>
              </Flex>
            </>
          )}
        </Flex>
      </CardBody>
    </Card>
    </motion.div>
  );
};

export default Greeting;

